import { useAuth } from 'react-oidc-context';

import AutoSignin from '@/features/auth/components/auto-signin';

const RegisterPage = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    window.location.assign(import.meta.env.VITE_APP_EXCHANGE_URL);
    return null;
  }

  return (
    <AutoSignin
      args={{
        extraQueryParams: {
          screen_hint: 'signup',
        },
      }}
    />
  );
};
RegisterPage.displayName = 'RegisterPage';

export default RegisterPage;
